import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import { authMiddleware, autoLogin, avoidLogin } from '@/middleware/auth';
import HomePage from '@/views/home/HomePage.vue'
import LoginPage from '@/views/Login.vue';
import TestPage from '@/views/Test.vue';
import ReservationsCompletedPage from '@/views/reservations/ReservationsCompletedPage.vue';
import ContactPage from '@/views/contact/ContactPage.vue';
import ReservationDetailPage from '@/views/reservations/ReservationDetailPage.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    component: LoginPage,
    meta: {
      notAuthenticated: true
    },
    beforeEnter: avoidLogin
  },
  {
    path: '/home',
    component: HomePage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/test',
    component: TestPage
  },
  {
    path: '/reservations-completed',
    component: ReservationsCompletedPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/contact',
    component: ContactPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reservation/:id',
    component: ReservationDetailPage,
    meta: {
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(autoLogin);
router.beforeEach(authMiddleware);

export default router
